import * as React from 'react';
import {useFormikContext} from 'formik';
import {CourseObject} from 'api/course';
import Row from 'components/Row';
import Column from 'components/Column';
import Input from 'components/Input';
import FormContainer from '../../containers/FormContainer';

/**
 * The post message form part of settings
 * @return {React.ReactElement}
 * @constructor
 */
export default function PostMessageForm(): React.ReactElement {
  const formContext = useFormikContext<Partial<CourseObject>>();

  /**
   * Render content
   * @return {JSX.Element}
   */
  function renderContent(): JSX.Element {
    /**
     * Render text field
     * @return {JSX.Element}
     */
    function renderText(): JSX.Element {
      /**
       * Handle input blur
       * @param {React.FocusEvent<HTMLInputElement>} event
       */
      function handleBlur(event: React.FocusEvent<HTMLInputElement>): void {
        formContext.setFieldValue('postMessage.text', event.target.value);
        formContext.submitForm();
      }

      return (
        <Column>
          <Row>
            <Column>
              <Input
                type="text"
                defaultValue={formContext.values.postMessage?.text}
                onBlur={handleBlur}
                required
              />
            </Column>
          </Row>
        </Column>
      );
    }

    return (
      <Row>
        {renderText()}
      </Row>
    );
  }
  return (
    <FormContainer
      property="postMessage"
      label="Сообщение по завершению"
      collapse
    >
      {renderContent()}
    </FormContainer>
  );
}
